export function filterQueryParams(
  url: string,
  filterKeys: (string | RegExp)[],
) {
  if (!url.includes('?')) {
    return url
  }
  const [urlPart, queryParams] = url.split('?')
  const originalParams = new URLSearchParams(queryParams)
  const filteredParams = Array.from(originalParams.entries()).filter(([k]) => {
    for (const filterKey of filterKeys) {
      if (filterKey instanceof RegExp && filterKey.test(k)) {
        return false
      } else if (filterKey === k) {
        return false
      }
    }
    return true
  })
  return `${urlPart}?${new URLSearchParams(filteredParams)}`.replace(/\?$/, '')
}

export function constructFullUrl(url: URL) {
  const { protocol, hostname, port } = url

  const isDefaultPort = port === '80' || port === '443'

  let extension = ''

  if (!isDefaultPort) {
    extension = `:${port}`
  }

  return `${protocol}//${hostname}${extension}`
}

export function formatUrlWithEncrypedGa(path = '', gaId = '') {
  if (!path.startsWith('https://') || !gaId) return ''
  const url = new URL(path)
  const searchParams = url.searchParams
  if (searchParams.get('hhgclid')) {
    searchParams.delete('hhgclid')
    searchParams.set('hhgclid', gaId)
    return `${url.origin}${url.pathname}?${searchParams.toString()}`
  }
  return path
}

function isParsable(url: string, base?: string): boolean {
  try {
    new URL(url, base)
    return true
  } catch {
    return false
  }
}

export function configCdnImageSize(
  imageUrl: string,
  options: { width: number; quality?: number },
): string {
  if (isParsable(imageUrl)) {
    const dpr = window.devicePixelRatio || 1
    const urlObj = new URL(imageUrl)

    urlObj.searchParams.set('w', (options.width * dpr).toString())

    const responseSizeRegExp = new RegExp('-\\d+x\\d+(?=\\.\\w+$)', 'g')
    const cleanedPathname = urlObj.pathname.replace(responseSizeRegExp, '')

    return `${urlObj.origin}${cleanedPathname}${urlObj.search}`
  }

  return imageUrl
}
